import {
  AccordionDetails,
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Popper,
  Select,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { tabButton } from "../../style/PatientTestStyle";
import {
  menuItemStyle,
  menuItemStyleContentWidth,
  textfieldText,
} from "../../style/AppointmentStyle";
import UseGetMedicalTestList from "../../helper/UseGetMedicalTestList";
import {
  getMedicalTestById,
  getProcedureMedicalTestById,
  rePrintInvoice,
} from "../../connections/getApi";
import ReportPrint from "../PrintCompoents/ReportPrint";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { postAdmission, saveAndPrintTestData } from "../../connections/postApi";
import { showToast } from "../../utils/toastUtil";
import {
  setPatientInvoice,
  setPrintData,
  setRenderInvoice,
} from "../../redux/slices/billingSlice";
import { putRefundMoney } from "../../connections/putApi";
import dayjs from "dayjs";
import {
  orangeButton,
  primaryBtnTeal,
  textfieldTextBlueBorder,
} from "../../style/PatientDetailsStyle";
import AddIcon from "@mui/icons-material/Add";
import { xBtn } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import { cancelTest } from "../../connections/deleteApi";
import { selectFieldTextBlueBr } from "../../style/PharmacyStyle";
import IpdInvoices from "./IpdInvoices";
import { isTodayDate } from "../../utils/constantFunctions";

const initial = [{ name: "", test: "", cost: 0, discount: 0 }];
const instate = {
  Lab: false,
  "X-Ray": false,
  Procedure: false,
  Dietician: false,
  Physiotherapist: false,
  Psychologist: false,
};
const initialState = {
  Dietician: { id: "0" },
  DieticianPlan: { id: "1" },
  Physiotherapist: { id: "0" },
  PhysiotherapistPlan: { id: "1" },
  Psychologist: { id: "0" },
  PsychologistPlan: { id: "1" },
};
const PatientsTest = () => {
  const {
    billing: { data: patientData, inVoiceData, medicalTest },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { data: listData, isLoading } = UseGetMedicalTestList();
  const [department, setDepartment] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [departmentTest, setDepartmentTest] = useState({
    Lab: [],
    "X-Ray": [],
    Procedure: [],
    Dietician: [],
    Physiotherapist: [],
    Psychologist: [],
  });
  const [selectedSpecialist, setSelectedSpecialist] = useState({
    Dietician: { id: null },
    DieticianPlan: { id: null },
    Physiotherapist: { id: null },
    PhysiotherapistPlan: { id: null },
    Psychologist: { id: null },
    PsychologistPlan: { id: null },
  });

  const [labTests, setLabTests] = useState([
    {
      name: "",
      test: "",
      amount: 0,
      discount: 0,
      quantity: 1,
      cost_per_unit: 0,
      discount_per_unit: 0,
    },
  ]);
  const [xRayTest, setXrayTest] = useState([
    { name: "", test: "", cost: 0, discount: 0 },
  ]);
  const [procedureTest, setProcedureTest] = useState([
    {
      id: "",
      name: "",
      test: "",
      amount: 0,
      discount: 0,
      quantity: 1,
      cost_per_unit: 0,
      discount_per_unit: 0,
    },
  ]);
  const [expanded, setExpanded] = useState({
    Lab: false,
    "X-Ray": false,
    Procedure: false,
    Dietician: false,
    Physiotherapist: false,
    Psychologist: false,
  });
  const now = dayjs().format("YYYY-MM-DDTHH:mm");

  const [admission, setAdmission] = useState({
    room_no: null,
    bed_no: null,
    checkin: now,
    checkout: now,
    id: null,
    quantity: { id: "", quantity: 1 },
  });

  // const [invoiceId, setInvoice] = useState("");
  // const [planInvoice, setPlanInvoice] = useState({});
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalBill, setTotalBill] = useState(0);
  const [totalDiscountXray, setTotalDiscountXray] = useState(0);
  const [totalBillXray, setTotalBillXray] = useState(0);
  const [totalDiscountProcedure, setTotalDiscountProcedure] = useState(0);
  const [totalBillProcedure, setTotalBillProcedure] = useState(0);
  const testReportRef = useRef();
  const [departmentIds, setDepartmentIds] = useState([]);
  // const [addTest, setAddTest] = useState(false);
  const [rePrint, setRePrint] = useState({
    Lab: false,
    "X-Ray": false,
    Procedure: false,
    Dietician: false,
    Physiotherapist: false,
    Psychologist: false,
  });
  const [paymentType, setPaymentType] = useState("");
  const [activeTab, setActiveTab] = useState("Lab");

  const handleAddTest = (key) => {
    // setAddTest(!addTest);
    if (key === "lab") {
      setLabTests([
        ...labTests,
        {
          test: "",
          amount: 0,
          discount: 0,
          quantity: 1,
          cost_per_unit: 0,
          discount_per_unit: 0,
        },
      ]);
    } else if (key === "xray") {
      setXrayTest([...xRayTest, { test: "", amount: 0, discount: 0 }]);
    } else if (key === "procedure") {
      setProcedureTest([
        ...procedureTest,
        {
          id: "",
          name: "",
          test: "",
          amount: 0,
          discount: 0,
          quantity: 1,
        },
      ]);
    }
  };
  // console.log(labTests, 'labTests');

  const handleDeleteTest = (index, key, id) => {
    if (key === "lab") {
      const newLabTests = labTests.filter((_, i) => i !== index);
      if (id) {
        refundTest(id);
      }
      setLabTests(newLabTests);
    } else if (key === "xray") {
      const newXRayTest = xRayTest.filter((_, i) => i !== index);
      if (id) {
        refundTest(id);
      }
      setXrayTest(newXRayTest);
    } else if (key === "procedure") {
      const newProcedure = procedureTest.filter((_, i) => i !== index);
      if (id) {
        refundTest(id);
      }
      setProcedureTest(newProcedure);
    }
  };

  // console.log(procedureTest, 'procedureTest')

  const handleSelectTest = async (index, value, key) => {
    if (key === "lab") {
      const testData = await getMedicalTestById(value?.id);
      // console.log(testData, "test data by id");
      // console.log(testData, 'testData')
      const newLabTests = labTests.map((test, i) =>
        i === index
          ? {
              ...test,
              // test: value,
              // cost: selectedTest.cost,
              // discount: selectedTest.discount,
              ...testData,
              cost_per_unit: testData?.amount,
              discount_per_unit: testData?.discount,
              amount:
                test?.quantity > 1
                  ? (test?.quantity || 1) * (testData?.amount ?? 0)
                  : (testData?.amount ?? test?.amount ?? 0),
              discount:
                testData?.discount !== null && testData?.discount !== undefined
                  ? test?.quantity > 1
                    ? (test?.quantity || 1) * testData?.discount
                    : testData?.discount
                  : (test?.discount ?? 0),
            }
          : test,
      );
      const isDuplicate = labTests.some((test) => test.id === testData.id);

      if (!isDuplicate) {
        setLabTests(newLabTests);
      } else {
        const updatedTests = labTests.filter((_, i) => i !== index);
        setLabTests(updatedTests);
      }
      // setLabTests(newLabTests);
    } else if (key === "xray") {
      const testData = await getMedicalTestById(value?.id);

      const newLabTests = xRayTest.map((test, i) =>
        i === index
          ? {
              ...test,
              // test: value,
              // cost: selectedTest.cost,
              // discount: selectedTest.discount,
              ...testData,
            }
          : test,
      );
      setXrayTest(newLabTests);
    } else if (key === "procedure") {
      const type = departmentTest?.Procedure?.consumables?.includes(value)
        ? "consumable"
        : "test";

      const testData = await getProcedureMedicalTestById(value?.id, type);

      if (!testData) {
        return;
      }

      // if (
      //   type === "consumable" &&
      //   testData?.consumables_composite_fields?.length > 0
      // ) {
      //   // console.log(testData, "testData");
      //   const compositeFields = testData?.consumables_composite_fields?.map(
      //     (field) => ({
      //       ...field,
      //       parentId: value?.id, // Reference the parent consumable
      //       type,
      //     })
      //   ).filter((field) => !procedureTest.some((test) => test.id === field.id));

      //   // Insert composite fields into the procedureTest array
      //   const newTests = [
      //     ...procedureTest.slice(0, index),
      //     ...compositeFields,
      //     ...procedureTest.slice(index + 1),
      //   ];
      // //  console.log(compositeFields , 'compositeFields')
      //   // console.log(newTests , 'newTests');
      //   setProcedureTest(newTests);
      // }

      if (type === "test" && testData?.composite_fields?.length > 0) {
        // Handle composite fields for tests
        console.log(testData, "testData");
        const compositeFields = testData?.composite_fields
          ?.map((field) => ({
            ...field,
            parentId: value?.id, // Reference the parent test
            type,
          }))
          .filter(
            (field) => !procedureTest.some((test) => test.id === field.id),
          );

        const newTests = [
          ...procedureTest.slice(0, index),
          ...compositeFields.map((test) => ({
            ...test,
            cost_per_unit: test?.amount,
            discount_per_unit: test?.discount,
            amount:
              test?.quantity > 1
                ? (test?.quantity || 1) * (test?.amount ?? 0)
                : (test?.amount ?? test?.amount ?? 0),
            discount:
              test?.discount !== null && test?.discount !== undefined
                ? test?.quantity > 1
                  ? (test?.quantity || 1) * test?.discount
                  : test?.discount
                : (test?.discount ?? 0),
          })),
          ...procedureTest.slice(index + 1),
        ];
        setProcedureTest(newTests);
      } else {
        // For simple procedure without composite fields
        const newTests = procedureTest.map((test, i) =>
          i === index
            ? {
                ...test,
                ...testData,
                quantity: 1,
                cost_per_unit: testData?.amount,
                discount_per_unit: testData?.discount,
                amount:
                  test?.quantity > 1
                    ? (test?.quantity || 1) * (testData?.amount ?? 0)
                    : (testData?.amount ?? test?.amount ?? 0),
                discount:
                  testData?.discount !== null &&
                  testData?.discount !== undefined
                    ? test?.quantity > 1
                      ? (test?.quantity || 1) * testData?.discount
                      : testData?.discount
                    : (test?.discount ?? 0),
                type, // Ensure type is correctly set
              }
            : { ...test },
        );
        const isDuplicate = procedureTest.some(
          (test) => test.id === testData.id,
        );

        if (!isDuplicate) {
          setProcedureTest(newTests);
        } else {
          const updatedTests = procedureTest.filter((_, i) => i !== index);
          setProcedureTest(updatedTests);
        }
        //  setProcedureTest(newTests);
      }
    }
  };

  const handleSpecialistChange = (event, key) => {
    const selectedId = event.target.value;
    // setSelectedSpecialist(selectedId);
    const selectedSpecialistData = departmentTest?.[key]?.specialists?.find(
      (el) => el.id === selectedId,
    );

    setSelectedSpecialist((prev) => ({
      ...prev,
      [key]: selectedSpecialistData,
    }));
  };

  const handleChangePlan = async (event, key, updater) => {
    const selectedId = event.target.value;
    // setSelectedSpecialist(selectedId);
    const selectedSpecialistData = selectedSpecialist?.[
      key
    ]?.specialist_plans?.find((el) => el.id === selectedId);
    // console.log(selectedSpecialistData);
    setSelectedSpecialist((prev) => ({
      ...prev,
      [updater]: selectedSpecialistData,
    }));
  };

  // console.log(department);
  // console.log(patientData, "patientData?.payload");
  const handleSaveAndPrint = async (key, testArray) => {
    // console.log(testArray, 'testArray')

    // console.log(
    //   !patientData?.uid ||
    //     !patientData?.payload?.uid ||
    //     !patientData?.id ||
    //     !patientData?.payload?.id,
    //   "patientData?.payload"
    // );

    if (
      (!patientData?.uid || !patientData?.id) &&
      (!patientData?.payload?.uid || !patientData?.payload?.id)
    ) {
      showToast("Please select a patient first ", "ERROR");
      return null;
    }

    if (!paymentType) {
      showToast("Please select Payment Mode", "ERROR");
      setButtonLoading(false);
      return;
    }

    setButtonLoading(true);
    let res;

    let admissionResponse = null;
    if (key === "Procedure" && admission?.bed_no) {
      if (testArray?.length === 0) {
        showToast(
          "Admission requires at least one selected service or test",
          "ERROR",
        );
        setButtonLoading(false);
        return;
      }
      if (!admission?.checkin || !admission?.checkout) {
        showToast("Please select valid Check In Check out date", "ERROR");
        setButtonLoading(false);
        return;
      }
      res = await postAdmission(admission);
      if (res?.status?.status === "SUCCESS") {
        admissionResponse = res?.payload;
      }
      setButtonLoading(false);
      showToast(`Admission ${res?.status?.status}`, res?.status?.status);
    }

    if (testArray?.length === 0) {
      setButtonLoading(false);
      return null;
    }

    // console.log(testArray, 'testArray')
    if (!testArray?.length || testArray.every((item) => !item?.id)) {
      setButtonLoading(false);
      return null;
    }

    // const testIds =
    //   key === "Procedure"
    //     ? testArray?.map((el) => ({
    //         id: el?.id?.toString(),
    //         quantity: el?.quantity > 0 ? el?.quantity?.toString() : "1",
    //       }))
    //     : testArray?.map((el) => el.id);

    // let mapItemsToPayload = (items) =>
    //   items.map((el) => ({
    //     id: el?.id?.toString(),
    //     quantity: el?.quantity > 0 ? el?.quantity?.toString() : "1",
    //   }));

    let mapItemsToPayload = (items) =>
      items.map((el) => {
        const amount =
          typeof el?.amount === "number" && !isNaN(el.amount) ? el.amount : 0;
        const cost_per_unit =
          typeof el?.cost_per_unit === "number" && !isNaN(el.cost_per_unit)
            ? el.cost_per_unit
            : 0;
        const discount =
          typeof el?.discount === "number" && !isNaN(el.discount)
            ? el.discount
            : 0;
        const quantity = el?.quantity > 0 ? el.quantity : 1;

        return {
          id: el?.id?.toString(),
          quantity: quantity.toString(),
          cost_per_unit: cost_per_unit,
          cost: cost_per_unit * quantity,
          discount_per_unit: discount / quantity || 1,
          discount: discount,
          amount: amount - discount,
        };
        // "quantity": "2",
        //   "cost_per_unit": "100",
        //     "cost": "200",
        //       "discount_per_unit": "5",
        //         "discount": "10",
        //           "amount": "190"
      });

    const testIds =
      key === "Procedure"
        ? mapItemsToPayload(
            testArray.filter(
              (item) =>
                item?.invoice_itemable_type === "MedicalTest" ||
                item?.type === "test",
            ),
          )
        : mapItemsToPayload(testArray);

    // mapItemsToPayload = (items) =>
    //   items.map((el) => ({
    //     id: el?.id?.toString(),
    //     quantity: el?.quantity > 0 ? el?.quantity?.toString() : "1",
    //   }));
    // let mapLabTests = (items) =>
    //   items.map((el) => {
    //     const amount = typeof el?.amount === "number" && !isNaN(el.amount) ? el.amount : 0;
    //     const discount = typeof el?.discount === "number" && !isNaN(el.discount) ? el.discount : 0;
    //     const quantity = el?.quantity > 0 ? el.quantity : 1;

    //     return {
    //       id: el?.id?.toString(),
    //       quantity: quantity.toString(),
    //       amount,
    //       discount,
    //       net: (amount - discount) * quantity,
    //     };
    //   });

    // const testIds =
    //   key === "Procedure"
    //     ? mapItemsToPayload(
    //         testArray.filter(
    //           (item) =>
    //             item?.invoice_itemable_type === "MedicalTest" ||
    //             item?.type === "test",
    //         ),
    //       )
    //     : testArray?.map((el) => el?.id);

    const consumablesIds =
      key === "Procedure"
        ? mapItemsToPayload(
            testArray.filter(
              (item) =>
                item.invoice_itemable_type === "Consumable" ||
                item.type === "consumable",
            ),
          )
        : testArray.map((el) => el.invoice_itemable_id);
    // console.log(testArray, department);

    const id = departmentIds?.find((el) => el[key]);

    const hasInvalidTestIds =
      key === "Procedure"
        ? testIds?.some((el) => !el?.id)
        : testIds?.some((el) => el === null || el === undefined);
    // console.log(testArray, "testArray");
    // console.log(hasInvalidTestIds, "hasInvalidTestIds", testIds);
    if (hasInvalidTestIds && key === "Procedure") {
      showToast("Please Select a Test", "ERROR");
      setButtonLoading(false);
      return;
    }

    const getDepartmentIdByName = (name) => {
      const dep = departmentIds?.find((el) => el[name]);
      return dep ? dep[name] : null;
    };
    const isProcedure = key === "Procedure";
    const isDaycare = isProcedure && res?.payload?.id;

    const department_id = isProcedure
      ? isDaycare
        ? getDepartmentIdByName("Daycare") // 9
        : getDepartmentIdByName("Daycare") // 8
      : getDepartmentIdByName(key);

    const payload = {
      invoices: [
        {
          invoice_type:
            key === "Procedure"
              ? res?.payload?.id // if admission exist then send daycare  otherwise procedure
                ? "daycare"
                : "daycare"
              : "tests",
          department_id,
          tests: key === "Lab" ? mapItemsToPayload(testArray) : testIds,
          // discount: key === "Lab" ? totalDiscount : totalDiscountProcedure,
          // total:
          //   key === "Lab"
          //     ? totalBill + totalDiscount
          //     : totalBillProcedure + totalDiscountProcedure,
          // grand_total: key === "Lab" ? totalBill : totalBillProcedure,
          discount:
            key === "Lab"
              ? totalDiscount
              : key === "X-Ray"
                ? totalDiscountXray
                : totalDiscountProcedure,
          total:
            key === "Lab"
              ? totalBill + totalDiscount
              : key === "X-Ray"
                ? totalBillXray + totalDiscountXray
                : totalBillProcedure + totalDiscountProcedure,
          grand_total:
            key === "Lab"
              ? totalBill
              : key === "X-Ray"
                ? totalBillXray
                : totalBillProcedure,
          ...(key === "Procedure" ? { consumables: consumablesIds } : {}),
        },
      ],
      dob: patientData?.payload?.dob || patientData?.dob,
      uid: patientData?.payload?.uid || patientData?.uid,
      gender: patientData?.payload?.gender || patientData?.gender,
      name: patientData?.payload?.full_name || patientData?.full_name,
      mobile: patientData?.payload?.mobile || patientData?.mobile,
      payment_mode: paymentType,
    };

    if (res?.payload?.id || inVoiceData?.admission?.id) {
      payload["admission_id"] = res?.payload?.id || inVoiceData?.admission?.id;
    }
    if (inVoiceData?.id) {
      if (key === "Procedure" && inVoiceData?.department_name === "Daycare") {
        // If key is "procedure" and procedure is "daycare"
        payload.invoices[0]["old_invoice_id"] = inVoiceData?.id;
      } else if (inVoiceData?.department_name === key) {
        // For other keys, check department_name
        payload.invoices[0]["old_invoice_id"] = inVoiceData?.id;
      }
    }
    // if (invoiceId?.length > 0 && invoiceId[0]?.id) {
    //   payload.invoices[0]["old_invoice_id"] = invoiceId[0]?.id;
    // }

    if (!paymentType) {
      showToast("Please select Payment Mode", "ERROR");
      setButtonLoading(false);
      return;
    }
    try {
      // if (Object.keys(patientData?.payload)?.length > 5) {
      const data = await saveAndPrintTestData(payload);

      if (data?.status?.status === "SUCCESS") {
        // setInvoice(data?.payload?.invoices);
        dispatch(setPatientInvoice([]));
        // dispatch(setPrintData(data?.payload));
        dispatch(
          setPrintData({
            ...data?.payload,
            admissionDetails: admissionResponse || null,
          }),
        );

        setRePrint((prev) => ({
          ...prev,
          [key]: true,
        }));
        dispatch(setRenderInvoice());
        setTimeout(() => {
          handlePrint();
        }, 100);
        showToast("Generating Invoice", data?.status?.status);
        setLabTests([]);
        setXrayTest([]);
        setProcedureTest([]);
        setAdmission({
          room_no: null,
          bed_no: null,
          checkin: null,
          checkout: null,
          id: null,
          quantity: { id: "", quantity: 1 },
        });
        setPaymentType("");
        setButtonLoading(false);
      } else if (data?.status?.status === "ERROR") {
        showToast(data?.status?.message, data?.status?.status);
        setRePrint((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
      // }
      setButtonLoading(false);
    } catch (error) {
      setRePrint((prev) => ({
        ...prev,
        [key]: false,
      }));
      showToast(error?.status?.message, error?.status?.status);
      setButtonLoading(false);
    }
    setButtonLoading(false);
  };
  // console.log(planInvoice, "planInvoice");

  const handleSaveAndPrintPlans = async (key, testObj) => {
    if (!paymentType) {
      showToast("Please select Payment Mode", "ERROR");
      setButtonLoading(false);
      return;
    }
    // const testIds = testArray?.map((el) => el.id);

    if (
      (!patientData?.uid || !patientData?.id) &&
      (!patientData?.payload?.uid || !patientData?.payload?.id)
    ) {
      showToast("Please select a patient first ", "ERROR");
      return null;
    }

    dispatch(setPrintData([]));
    const id = departmentIds?.find((el) => el[key]);
    // if (typeof testObj?.id) {
    //   showToast("Please Select a Plan", "ERROR");
    //   return;
    // }
    if (testObj?.id) {
      showToast("Please Select a Plan", "ERROR");
      return null;
    }
    const payload = {
      invoices: [
        {
          invoice_type: "consultancy",
          department_id: id[key],
          tests: testObj?.id,
        },
      ],
      dob: patientData?.payload?.dob,
      uid: patientData?.payload?.uid,
      gender: patientData?.payload?.gender,
      name: patientData?.payload?.full_name,
      mobile: patientData?.payload?.mobile,
      payment_mode: paymentType,
    };
    if (inVoiceData?.id) {
      if (key === "Procedure" && inVoiceData?.department_name === "Daycare") {
        // If key is "procedure" and procedure is "daycare"
        payload.invoices[0]["old_invoice_id"] = inVoiceData?.id;
      } else if (inVoiceData?.department_name === key) {
        // For other keys, check department_name
        payload.invoices[0]["old_invoice_id"] = inVoiceData?.id;
      }
    }
    // if (planInvoice[key]?.length > 0 && planInvoice[key][0]?.id) {
    //   payload.invoices[0]["old_invoice_id"] = planInvoice[key][0].id;
    // }

    try {
      // if (Object.keys(patientData?.payload)?.length > 5) {
      const data = await saveAndPrintTestData(payload);

      if (data?.status?.status === "SUCCESS") {
        // setPlanInvoice((prev) => ({
        //   ...prev,
        //   [key]: data?.payload?.invoices,
        // }));
        dispatch(setPatientInvoice([]));
        dispatch(setPrintData(data?.payload));
        setRePrint((prev) => ({
          ...prev,
          [key]: true,
        }));
        dispatch(setRenderInvoice());
        showToast("Generating Invoice", data?.status?.status);
        setSelectedSpecialist({
          Dietician: { id: null },
          DieticianPlan: { id: null },
          Physiotherapist: { id: null },
          PhysiotherapistPlan: { id: null },
          Psychologist: { id: null },
          PsychologistPlan: { id: null },
        });
      } else if (data?.status?.status === "ERROR") {
        showToast(data?.status?.message, data?.status?.status);
        setRePrint((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
      // }
    } catch (error) {
      setRePrint((prev) => ({
        ...prev,
        [key]: false,
      }));
      showToast(error?.status?.message, error?.status?.status);
    }
  };

  const handleAccordionChange = (panel) => {
    setExpanded({
      ...expanded,
      [panel]: !expanded?.[panel],
    });
  };

  const handleRePrint = async (key, testArray) => {
    setButtonLoading(true);
    let admissionResponse = null;
    if (admission?.id) {
      admissionResponse = {
        room_no: admission?.room_no,
        bed_no: admission?.bed_no,
        checkin: admission?.checkin,
        checkout: admission?.checkout,
        id: admission?.id,
      };
    }
    try {
      const result = await rePrintInvoice(inVoiceData?.id);
      if (result?.payload?.id) {
        showToast("Re-generating Print..", "SUCCESS");
        dispatch(
          setPrintData({
            invoices: [result?.payload],
            admissionDetails: admissionResponse || null,
          }),
        );
        setLabTests([]);
        setXrayTest([]);
        setProcedureTest([]);
        setAdmission({
          room_no: null,
          bed_no: null,
          checkin: null,
          checkout: null,
          id: null,
          quantity: { id: "", quantity: 1 },
        });
        dispatch(setPatientInvoice([]));
        // dispatch(setData([]));

        // dispatch(setPatientId(null));

        setSelectedSpecialist({
          Dietician: { id: null },
          DieticianPlan: { id: null },
          Physiotherapist: { id: null },
          PhysiotherapistPlan: { id: null },
          Psychologist: { id: null },
          PsychologistPlan: { id: null },
        });
      } else {
        showToast("Error in Re-generating Print..", "ERROR");
      }
      setButtonLoading(false);
    } catch (error) {
      showToast(error?.status?.message, error?.status?.status);
      setButtonLoading(false);
    }

    setButtonLoading(false);
  };

  const handleRefund = async (val) => {
    setButtonLoading(true);
    try {
      const data = await putRefundMoney(inVoiceData?.id);
      if (data?.payload?.id) {
        showToast("Refund ..Success", "SUCCESS");
        handleAccordionChange(val);
        dispatch(setPatientInvoice([]));
        // dispatch(setData([]));
        dispatch(setRenderInvoice());
        setLabTests([]);
        setXrayTest([]);
        setProcedureTest([]);
        setAdmission({
          room_no: null,
          bed_no: null,
          checkin: null,
          checkout: null,
          id: null,
          quantity: { id: "", quantity: 1 },
        });
        // dispatch(setPatientId(null));

        setSelectedSpecialist({
          Dietician: { id: "0" },
          DieticianPlan: { id: "1" },
          Physiotherapist: { id: "0" },
          PhysiotherapistPlan: { id: "1" },
          Psychologist: { id: "0" },
          PsychologistPlan: { id: "1" },
        });
      } else {
        showToast(data?.status?.message, "ERROR");
      }
      setButtonLoading(false);
    } catch (error) {
      showToast(error?.status?.message, error?.status?.status);
      setButtonLoading(false);
    }
  };

  const refundTest = async (id) => {
    try {
      const data = await cancelTest(id);
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (inVoiceData?.department_name === "IPD") {
      setActiveTab("IPD");
      return;
    }
    if (inVoiceData?.department_name === "Consultancy") {
      setLabTests([]);
      setXrayTest([]);
      setProcedureTest([]);
      // dispatch(setPatientId(null));

      setSelectedSpecialist({
        Dietician: { id: "0" },
        DieticianPlan: { id: "1" },
        Physiotherapist: { id: "0" },
        PhysiotherapistPlan: { id: "1" },
        Psychologist: { id: "0" },
        PsychologistPlan: { id: "1" },
      });
    } else if (inVoiceData && Object.keys(inVoiceData)?.length) {
      setExpanded({
        ...instate,
        [inVoiceData?.department_name]: true,
      });
      if (inVoiceData?.department_name === "Daycare") {
        setExpanded({
          ...instate,
          Procedure: true,
        });
        setActiveTab("Procedure");
      }
      // const result = inVoiceData?.invoice_items?.map((item) => item);
      const result = inVoiceData?.invoice_items?.map((item) => ({
        ...item,
        itemId: item.id,
        id: item?.invoice_itemable_id,
        name: item?.name,
        discount: item?.discount,
        amount: item?.cost,
        // ...item.lab,
        // report_status
      }));
      // console.log(result, "result");
      const planResult = departmentTest[
        inVoiceData?.department_name
      ]?.specialists?.map((el) => el.specialist_plans);

      if (inVoiceData?.department_name === "Lab") {
        setDepartmentTest((prev) => ({
          ...prev,
          [inVoiceData?.department_name]: [...departmentTest?.Lab, ...result],
        }));
        setLabTests(result);
        setActiveTab("Lab");
      } else if (inVoiceData?.department_name === "X-Ray") {
        setDepartmentTest((prev) => ({
          ...prev,
          [inVoiceData?.department_name]: result,
        }));
        setXrayTest(result);
        setLabTests(initial);
        setActiveTab("X-Ray");
      } else if (
        inVoiceData?.department_name === "Procedure" ||
        inVoiceData?.department_name === "Daycare"
      ) {
        const formattedCheckin = inVoiceData?.admission
          ? dayjs(inVoiceData?.admission?.checkin).format("YYYY-MM-DDTHH:mm")
          : null;

        const formattedCheckout = inVoiceData?.admission
          ? dayjs(inVoiceData?.admission?.checkout).format("YYYY-MM-DDTHH:mm")
          : null;
        setAdmission({
          room_no: +inVoiceData?.admission?.room_no || null,
          bed_no: +inVoiceData?.admission?.bed_no || null,
          checkin: formattedCheckin || null,
          checkout: formattedCheckout || null,
          id: inVoiceData?.admission?.id || null,
        });
        setProcedureTest(result);
        setDepartmentTest((prev) => ({
          ...prev,
          [inVoiceData?.department_name]: result,
        }));
        setActiveTab("Procedure");
      } else {
        setSelectedSpecialist(() => ({
          ...initialState,
          [inVoiceData?.department_name]: {
            id: result[0]?.specialist_id,
            full_name: inVoiceData?.invoice_items[0]?.name,
            specialist_plans: planResult ? planResult[0] : null,
          },
          [inVoiceData?.department_name + "Plan"]: {
            id: result[0]?.invoice_itemable_id,
          },
        }));
        // console.log(result, "result all");
        if (inVoiceData?.department_name === "Dietician") {
          setActiveTab("Dietician");
        }
        if (inVoiceData?.department_name === "Physiotherapist")
          setActiveTab("Physiotherapist");
        if (inVoiceData?.department_name === "Psychologist")
          setActiveTab("Psychologist");
        //  console.log(inVoiceData?.department_name)
      }
    } else if (inVoiceData?.length < 1) {
      setLabTests([]);
      setXrayTest([]);
      setProcedureTest([]);
      // dispatch(setPatientId(null));

      setSelectedSpecialist({
        Dietician: { id: "0" },
        DieticianPlan: { id: "1" },
        Physiotherapist: { id: "0" },
        PhysiotherapistPlan: { id: "1" },
        Psychologist: { id: "0" },
        PsychologistPlan: { id: "1" },
      });
    }
  }, [inVoiceData]);

  useEffect(() => {
    // const discount = labTests.reduce((acc, test) => acc + test.discount * (test.quantity > 0 ? test.quantity : 1), 0);
    // const bill = labTests.reduce((acc, test) => acc + test.amount * (test.quantity > 0 ? test.quantity : 1), 0);

    const discount = labTests.reduce((acc, test) => acc + test.discount, 0);
    const bill = labTests.reduce((acc, test) => acc + test.amount, 0);

    setTotalDiscount(Math.ceil(+discount));
    setTotalBill(Math.ceil(+bill - +discount));
    // setTotalBill(((+bill) - (+discount)).toFixed(2));
  }, [labTests]);

  useEffect(() => {
    const discount = xRayTest.reduce((acc, test) => acc + test.discount, 0);
    const bill = xRayTest.reduce((acc, test) => acc + test.amount, 0);
    // console.log(bill);
    setTotalDiscountXray(discount);
    setTotalBillXray(bill - discount);
  }, [xRayTest]);

  useEffect(() => {
    // const discount = procedureTest.reduce(
    //   (acc, test) =>
    //     acc + test.discount * (test.quantity > 0 ? test.quantity : 1),
    //   0
    // );

    // const bill = procedureTest.reduce(
    //   (acc, test) =>
    //     acc + test.amount * (test.quantity > 0 ? test.quantity : 1),
    //   0
    // );

    const discount = procedureTest.reduce(
      (acc, test) => acc + (test.discount ?? 0),
      0,
    );

    const bill = procedureTest.reduce(
      (acc, test) => acc + (test.amount ?? 0),
      0,
    );

    setTotalDiscountProcedure(Math.ceil(+discount));
    setTotalBillProcedure(Math.ceil(bill - discount));
  }, [procedureTest]);

  useEffect(() => {
    const updatedDepartmentTest = { ...departmentTest };
    const depIds = listData?.payload?.departments?.map((el) => {
      return {
        [el.name]: el.id,
      };
    });
    const depList = listData?.payload?.departments?.map((el) => el?.name);
    setDepartment(depList);
    setDepartmentIds(depIds);

    listData?.payload?.departments.forEach((department) => {
      if (updatedDepartmentTest.hasOwnProperty(department.name)) {
        updatedDepartmentTest[department.name] = department.medical_tests;
      }
    });

    setDepartmentTest(updatedDepartmentTest);
  }, [listData?.payload?.departments]);

  useEffect(() => {
    if (medicalTest?.length > 0) {
      const labTests = medicalTest
        ?.filter((test) => test.category === "LAB")
        .map(({ name, discount, amount, id }) => ({
          name,
          discount,
          amount,
          id,
        }));

      const xRayTests = medicalTest
        ?.filter((test) => test.category === "X-Ray")
        .map(({ name, discount, amount, id }) => ({
          name,
          discount,
          amount,
          id,
        }));
      const procedureTest = medicalTest
        ?.filter((test) => test.category === "Procedure")
        .map(({ name, discount, amount }) => ({ name, discount, amount }));
      const newExpanded = {
        Lab: medicalTest.some((test) => test.category === "LAB"), // Example name for Lab test
        "X-Ray": medicalTest.some((test) => test.category === "X-Ray"), // Example name for X-Ray test
        Procedure: false, // Set to false as an example, adjust based on your data
        Dietician: false,
        Physiotherapist: false,
        Psychologist: false,
      };
      // console.log(procedureTest, "vivek");
      setLabTests(labTests);
      setXrayTest(xRayTests);
      setExpanded(newExpanded);
      setProcedureTest(procedureTest);
    }
  }, [medicalTest]);

  const handlePrint = useReactToPrint({
    content: () => testReportRef.current,
    documentTitle: "Invoice Print",
    onAfterPrint: () => console.log("Print job finished"),
  });

  const shouldShowSavePrintButton = (invoiceData) => {
    // 1) null/undefined => show
    if (!invoiceData) return true;

    // 2) [] => show, [obj] => use first
    if (Array.isArray(invoiceData)) {
      if (invoiceData.length === 0) return true;
      invoiceData = invoiceData[0];
    }

    // 3) object => check date
    if (!invoiceData?.generated_at) return false;

    return (
      inVoiceData?.generated_at?.split(" ")[0] ===
      dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY")
    );
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        mb={"auto"}
        justifyContent={"center"}
        mt={0}
        sm={12}
        md={3.9}
        lg={4.6}
        sx={{
          marginRight: "-10px",
          border: "1px solid #E1E1E1",
          backgroundColor: "#FFFFFF",
          borderRadius: "30px",
          paddingTop: "15px",
        }}
      >
        {/* tabs for test  */}

        {isLoading ? (
          <Skeleton height={"75px"} width={"90%"} />
        ) : (
          <Box
            mb={1}
            mt={1}
            sx={{
              width: "90%",
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            {department?.includes("Lab") && (
              <Button
                onClick={() => setActiveTab("Lab")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "Lab"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  color: activeTab === "Lab" ? "white" : "#3A3A3A",
                  boxShadow:
                    activeTab === "Lab"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                }}
              >
                {" "}
                Lab
              </Button>
            )}

            {department?.includes("X-Ray") && (
              <Button
                onClick={() => setActiveTab("X-Ray")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "X-Ray"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  color: activeTab === "X-Ray" ? "white" : "#3A3A3A",
                  boxShadow:
                    activeTab === "X-Ray"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                }}
              >
                X-Ray
              </Button>
            )}

            {department?.includes("Procedure") && (
              <Button
                onClick={() => setActiveTab("Procedure")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "Procedure"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  boxShadow:
                    activeTab === "Procedure"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                  color: activeTab === "Procedure" ? "white" : "#3A3A3A",
                }}
              >
                Daycare
              </Button>
            )}

            {department?.includes("Dietician") && (
              <Button
                onClick={() => setActiveTab("Dietician")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "Dietician"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  boxShadow:
                    activeTab === "Dietician"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                  color: activeTab === "Dietician" ? "white" : "#3A3A3A",
                }}
              >
                Dietician
              </Button>
            )}

            {department?.includes("Physiotherapist") && (
              <Button
                onClick={() => setActiveTab("Physiotherapist")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "Physiotherapist"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  boxShadow:
                    activeTab === "Physiotherapist"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                  marginBottom: "10px",
                  color: activeTab === "Physiotherapist" ? "white" : "#3A3A3A",
                  fontFamily: "Outfit",
                  textTransform: "capitalize",
                }}
              >
                Physiotherapist
              </Button>
            )}

            {department?.includes("Psychologist") && (
              <Button
                onClick={() => setActiveTab("Psychologist")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "Psychologist"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  boxShadow:
                    activeTab === "Psychologist"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                  color: activeTab === "Psychologist" ? "white" : "#3A3A3A",
                }}
              >
                Psychologist
              </Button>
            )}

            {department?.includes("IPD") && (
              <Button
                onClick={() => setActiveTab("IPD")}
                sx={{
                  ...tabButton,
                  backgroundColor:
                    activeTab === "IPD"
                      ? "neutral.teal"
                      : "neutral.blueShadeBg",
                  color: activeTab === "IPD" ? "white" : "#3A3A3A",
                  boxShadow:
                    activeTab === "IPD"
                      ? "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px"
                      : "",
                }}
              >
                IPD
              </Button>
            )}
          </Box>
        )}

        {isLoading ? (
          <Skeleton height={"200px"} width={"90%"} />
        ) : (
          <Box
            mt={1}
            sx={{
              padding: "15px",
              borderTop: "1px solid #7A7A7A80",
              width: "100%",
            }}
          >
            {/* {"----------Lab Test accordion----------"} */}
            {activeTab === "Lab" && (
              <AccordionDetails
                sx={{ backgroundColor: "neutral.white", padding: "20px 20px" }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ alignItems: "center", justifyContent: "space-between" }}
                >
                  <Grid item sm={3} lg={3}>
                    <Typography variant="title1_medium">
                      Mode of Payment
                    </Typography>
                  </Grid>
                  <Grid item sm={8} lg={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            required
                            fullWidth
                            sx={{
                              ...selectFieldTextBlueBr,
                              minWidth: "120px",
                              width: "100%",
                              "&:hover": {
                                borderRadius: "8px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                              },
                            }}
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            name="payment_type"
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#A0A0A0" }}>
                                    Payment Mode
                                  </span>
                                );
                              }
                              return selected; // ✅ Show selected value
                            }}
                          >
                            <MenuItem value="Cash" sx={menuItemStyle}>
                              Cash
                            </MenuItem>
                            <MenuItem value="Card" sx={menuItemStyle}>
                              Card
                            </MenuItem>
                            <MenuItem value="Cheque" sx={menuItemStyle}>
                              Cheque
                            </MenuItem>
                            <MenuItem value="UPI" sx={menuItemStyle}>
                              UPI
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  mt={2}
                  container
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <Grid
                    item
                    sm={4}
                    lg={4}
                    sx={{
                      paddingLeft: 0,
                    }}
                  >
                    <Typography variant="title1_medium">Test Name</Typography>
                  </Grid>

                  <Grid alignItems={"start"} item sm={7} lg={7}>
                    <Box
                      display={"flex"}
                      gap={"1px"}
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      width="100%"
                    >
                      <Typography p={0} variant="title1_medium">
                        Quantity
                      </Typography>
                      <Typography
                        variant="title1_medium"
                        sx={{ marginRight: "20px" }}
                      >
                        Cost
                      </Typography>
                      <Typography
                        variant="title1_medium"
                        sx={{ marginRight: "20px" }}
                      >
                        Discount
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    alignItems={"end"}
                    sm={1}
                    item
                    lg={1}
                    sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
                  >
                    {/* <Box
                      sx={addMoreTestStyle}
                      onClick={() => handleAddTest("lab")}
                    >
                      <Typography variant="title1_medium">+</Typography>
                    </Box> */}
                    <IconButton
                      variant="contained"
                      sx={{ ...orangeButton, marginLeft: "8px" }}
                      onClick={() => handleAddTest("lab")}
                    >
                      <AddIcon
                        sx={{
                          width: "25px",
                          color: "neutral.white",
                          margin: "0px",
                          height: "25px",
                          padding: "0px",
                        }}
                      />
                    </IconButton>
                  </Grid>

                  {labTests?.map((test, index) => (
                    <Grid
                      key={index}
                      item
                      lg={12}
                      gap={1}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                      }}
                    >
                      <Grid item sm={4} lg={4}>
                        <Autocomplete
                          clearIcon={false}
                          sx={{
                            ...textfieldTextBlueBorder,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                              height: "40px",
                              padding: "9px !important",
                              "& input": {
                                padding: "8px",
                                fontSize: "14px",
                              },
                            },
                          }}
                          fullWidth
                          options={departmentTest?.Lab || []} // Ensure departmentTest.Lab is an array of objects
                          getOptionLabel={(option) => option.name} // Use the 'name' property for display
                          value={
                            departmentTest?.Lab?.find(
                              (testObj) => testObj?.name === test?.name,
                            ) ||
                            departmentTest[0]?.name ||
                            null
                          }
                          onChange={
                            (event, newValue) =>
                              handleSelectTest(index, newValue, "lab") // Pass the whole object
                          }
                          PopperComponent={(props) => (
                            <Grid item lg={8}>
                              <Popper
                                {...props}
                                placement="bottom-start"
                                style={menuItemStyleContentWidth}
                              />
                            </Grid>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Test"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                          renderOption={(props, option) => (
                            <MenuItem
                              sx={menuItemStyle}
                              {...props}
                              key={option.id}
                            >
                              {option.name}{" "}
                              {/* Display the 'name' of each test */}
                            </MenuItem>
                          )}
                        />
                      </Grid>

                      <Grid
                        item
                        sm={7}
                        lg={7}
                        sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
                      >
                        <Box
                          display={"flex"}
                          justifyContent={"space-between"}
                          gap={"8px"}
                          alignItems={"center"}
                          width="100%"
                        >
                          <TextField
                            type="number"
                            defaultValue={1}
                            value={test?.quantity || 1}
                            placeholder="quantity"
                            fullWidth
                            onChange={(e) => {
                              // const newQty = e.target.value;
                              const newQty = e.target.value.replace(
                                /[^0-9]/g,
                                "",
                              );
                              setLabTests((prev) => {
                                const updatedTests = [...prev];
                                updatedTests[index] = {
                                  ...updatedTests[index],
                                  quantity: +newQty, // Allow raw input
                                  amount: Math.ceil(
                                    +newQty * test?.cost_per_unit,
                                  ),
                                  discount:
                                    Math.ceil(
                                      +newQty * test?.discount_per_unit,
                                    ) || 0,
                                };
                                return updatedTests;
                              });
                            }}
                            onBlur={(e) => {
                              const newQty = +e.target.value;
                              setLabTests((prev) => {
                                const updatedTests = [...prev];
                                updatedTests[index] = {
                                  ...updatedTests[index],
                                  quantity: newQty > 0 ? newQty : 1, // Enforce minimum of 1
                                };
                                return updatedTests;
                              });
                            }}
                            inputProps={{
                              min: 1,
                              readOnly: true,
                            }}
                            sx={{
                              ...textfieldTextBlueBorder,
                            }}
                            // disabled
                          />

                          <TextField
                            type="number"
                            value={test?.amount || ""}
                            placeholder="Cost"
                            fullWidth
                            onChange={(e) => {
                              const newAmount = e.target.value;
                              // if (+newAmount < +test?.discount) {
                              //   showToast(
                              //     "cost  cannot be lesser than the test discount.",
                              //     "ERROR"
                              //   );
                              //   return;
                              // }

                              if (+newAmount > 0) {
                                setLabTests((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    amount: Math.ceil(+newAmount), // Temporarily set the raw input
                                    cost_per_unit:
                                      test.quantity > 0
                                        ? Math.ceil(+newAmount / test.quantity)
                                        : 0,
                                    // cost: newQty,   // Temporarily set the raw input
                                  };
                                  return updatedTests;
                                });
                              } else {
                                setLabTests((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    amount: newAmount, // keep raw string temporarily
                                  };
                                  return updatedTests;
                                });
                              }
                            }}
                            onBlur={(e) => {
                              // const newQty = e.target.value.replace(
                              //   /[^0-9]/g,
                              //   ""
                              // );
                              let newAmount = parseFloat(e.target.value);

                              if (isNaN(newAmount) || newAmount <= 0) {
                                newAmount = 1; // Set minimum valid value
                              }

                              if (+newAmount < +test?.discount) {
                                newAmount = +test?.discount; // Auto-correct to discount
                                showToast(
                                  "Cost cannot be less than discount. Adjusted automatically.",
                                  "ERROR",
                                );
                              }

                              setLabTests((prev) => {
                                const updatedTests = [...prev];
                                updatedTests[index] = {
                                  ...updatedTests[index],
                                  amount: newAmount > 0 ? +newAmount : 1, // Validate on blur
                                  cost_per_unit:
                                    test.quantity > 0
                                      ? +newAmount / test.quantity
                                      : 0,
                                  // cost: newQty > 0 ? newQty : 1,   // Validate on blur
                                };
                                return updatedTests;
                              });
                            }}
                            // inputProps={{
                            //   min: 1,
                            // }}
                            sx={{
                              ...textfieldTextBlueBorder,
                            }}
                          />

                          <TextField
                            type="number"
                            value={test?.discount || ""}
                            placeholder="Discount"
                            fullWidth
                            onChange={(e) => {
                              const newQty = e.target.value.replace(
                                /[^0-9]/g,
                                "",
                              ); // Raw input
                              // if (newQty > (+test?.amount || +test?.cost)) {
                              //   showToast("Discount cannot be greater than the test cost.", "ERROR");
                              //   return;
                              // }
                              setLabTests((prev) => {
                                const updatedTests = [...prev];
                                updatedTests[index] = {
                                  ...updatedTests[index],
                                  discount: Math.ceil(+newQty), // Temporarily store raw input
                                  discount_per_unit:
                                    +test.quantity > 0
                                      ? Math.ceil(+newQty / test.quantity)
                                      : 0,
                                };
                                return updatedTests;
                              });
                            }}
                            onBlur={(e) => {
                              const newQty = +e.target.value; // Convert to number on blur
                              setLabTests((prev) => {
                                const updatedTests = [...prev];
                                updatedTests[index] = {
                                  ...updatedTests[index],
                                  discount: newQty < 0 ? 0 : newQty,
                                };
                                return updatedTests;
                              });
                            }}
                            inputProps={{
                              min: 0,
                              readOnly: true,
                            }}
                            sx={{
                              ...textfieldTextBlueBorder,
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid sm={1} item lg={1}>
                        {/* <Box
                          sx={deleteTest}                         
                        > 
                          <RestoreFromTrashRoundedIcon
                            sx={{ width: "15px", height: "15px" }}
                            fontSize="small"
                          />
                        </Box> */}
                        <IconButton
                          sx={{
                            marginBottom: "7px",
                            display:
                              test?.report_status === "processing" ||
                              test?.report_status === "done" ||
                              !shouldShowSavePrintButton(inVoiceData)
                                ? "none"
                                : "",
                          }}
                          onClick={() =>
                            handleDeleteTest(index, "lab", test?.itemId)
                          }
                        >
                          <CloseIcon
                            sx={{
                              ...xBtn,
                              width: "23px",
                              height: "23px",
                            }}
                          />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <Grid
                    item
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    xs={12}
                  >
                    <Box>
                      <Typography variant="title1_medium">
                        Net Discount:{" "}
                      </Typography>
                      <Typography variant="title1_medium">
                        {totalDiscount}
                      </Typography>
                    </Box>

                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Typography variant="title1_medium">
                        Net Amount
                      </Typography>
                      <TextField
                        type="number"
                        value={totalBill}
                        placeholder="Net amount"
                        InputProps={{ readOnly: true }}
                        sx={{
                          ...textfieldTextBlueBorder,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      marginTop: "12px",
                    }}
                  >
                    <Box>
                      {inVoiceData &&
                        Object?.keys(inVoiceData)?.length > 0 &&
                        inVoiceData?.department_name === "Lab" &&
                        inVoiceData?.generated_at?.split(" ")[0] ===
                          dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY") && (
                          <Button
                            disabled={
                              buttonLoading ||
                              labTests?.length < 1 ||
                              inVoiceData?.generated_at?.split(" ")[0] !==
                                dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY")
                            }
                            onClick={() => handleRefund("Lab")}
                            sx={{
                              ...primaryBtnTeal,
                              color: "white",
                              borderRadius: "8px",
                              py: "3px",
                              marginRight: "10px",
                              border: "2px solid",
                              borderColor: "neutral.brown",
                              backgroundColor: "neutral.brown",
                              "&:hover": {
                                backgroundColor: "neutral.brown",
                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                              },
                            }}
                          >
                            <Typography variant="small_Text">refund</Typography>
                          </Button>
                        )}

                      {inVoiceData &&
                        Object?.keys(inVoiceData)?.length > 0 &&
                        inVoiceData?.department_name === "Lab" && (
                          <ReactToPrint
                            trigger={() => (
                              <Button
                                // fullWidth
                                // onClick={handleRePrint}
                                disabled={buttonLoading || labTests?.length < 1}
                                sx={{
                                  ...primaryBtnTeal,
                                  color: "white",
                                  borderRadius: "8px",
                                  py: "3px",
                                  border: "2px solid",
                                  borderColor: "neutral.main",
                                  backgroundColor: "neutral.main",
                                  "&:hover": {
                                    backgroundColor: "neutral.main",
                                    boxShadow:
                                      "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                  },
                                  marginRight: "10px",
                                }}
                              >
                                <Typography variant="small_Text">
                                  Re-Print
                                </Typography>
                              </Button>
                            )}
                            content={() => testReportRef.current}
                            onBeforeGetContent={() => handleRePrint()}
                          />
                        )}
                    </Box>

                    <Box>
                      {shouldShowSavePrintButton(inVoiceData) && (
                        <Button
                          disabled={buttonLoading}
                          onClick={() => handleSaveAndPrint("Lab", labTests)}
                          sx={{
                            ...primaryBtnTeal,
                            color: "white",
                            py: "3px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <Typography variant="small_Text">
                            Save & Print
                          </Typography>
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </AccordionDetails>
            )}

            {/* {"----------x-ray Test accordion----------"} */}
            {activeTab === "X-Ray" && (
              <AccordionDetails
                sx={{ backgroundColor: "neutral.white", padding: "20px 20px" }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ alignItems: "center", justifyContent: "space-between" }}
                >
                  <Grid item sm={3} lg={3}>
                    <Typography variant="title1_medium">
                      Mode of Payment
                    </Typography>
                  </Grid>
                  <Grid item sm={8} lg={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "1000%" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            required
                            fullWidth
                            sx={{
                              ...selectFieldTextBlueBr,
                              minWidth: "120px",
                              width: "100%",
                              "&:hover": {
                                borderRadius: "8px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                              },
                            }}
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            name="payment_type"
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#A0A0A0" }}>
                                    Payment Mode
                                  </span>
                                );
                              }
                              return selected; // ✅ Show selected value
                            }}
                          >
                            <MenuItem value="Cash" sx={menuItemStyle}>
                              Cash
                            </MenuItem>
                            <MenuItem value="Card" sx={menuItemStyle}>
                              Card
                            </MenuItem>
                            <MenuItem value="Cheque" sx={menuItemStyle}>
                              Cheque
                            </MenuItem>
                            <MenuItem value="UPI" sx={menuItemStyle}>
                              UPI
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  mt={2}
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <Grid
                    item
                    sm={4}
                    lg={4}
                    sx={{
                      paddingLeft: 0,
                    }}
                  >
                    <Typography variant="title1_medium">Test Name</Typography>
                  </Grid>
                  <Grid alignItems={"start"} item sm={7} lg={7}>
                    <Box
                      display={"flex"}
                      gap={"1px"}
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      width="100%"
                    >
                      <Typography p={0} variant="title1_medium">
                        quantity
                      </Typography>
                      <Typography
                        p={0}
                        variant="title1_medium"
                        sx={{ marginRight: "20px" }}
                      >
                        Cost
                      </Typography>
                      <Typography
                        p={0}
                        variant="title1_medium"
                        sx={{ marginRight: "20px" }}
                      >
                        Discount
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    sm={1}
                    item
                    lg={1}
                    sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
                  >
                    {/* <Box
                      sx={addMoreTestStyle}
                      onClick={() => handleAddTest("xray")}
                    >
                      <Typography variant="title1_medium">+</Typography>
                    </Box> */}
                    <IconButton
                      variant="contained"
                      sx={{ ...orangeButton, marginLeft: "8px" }}
                      onClick={() => handleAddTest("xray")}
                    >
                      <AddIcon
                        sx={{
                          width: "25px",
                          color: "neutral.white",
                          margin: "0px",
                          height: "25px",
                          padding: "0px",
                        }}
                      />
                    </IconButton>
                  </Grid>

                  {xRayTest?.map((test, index) => (
                    <Grid
                      key={index}
                      item
                      lg={12}
                      gap={1}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                      }}
                    >
                      <Grid item sm={4} lg={4}>
                        <Autocomplete
                          clearIcon={false}
                          sx={{
                            ...textfieldTextBlueBorder,
                            textTransform: "capitalize",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                              height: "40px",
                              padding: "9px !important",
                              "& input": {
                                padding: "8px",
                                fontSize: "14px",
                              },
                            },
                          }}
                          fullWidth
                          options={departmentTest?.["X-Ray"] || []} // Ensure departmentTest.Lab is an array of objects
                          getOptionLabel={(option) => option.name} // Use the 'name' property for display
                          value={
                            departmentTest?.["X-Ray"].find(
                              (testObj) => testObj.name === test.name,
                            ) || null
                          }
                          onChange={
                            (event, newValue) =>
                              handleSelectTest(index, newValue, "xray") // Pass the whole object
                          }
                          PopperComponent={(props) => (
                            <Grid item lg={8}>
                              <Popper
                                {...props}
                                placement="bottom-start"
                                style={menuItemStyleContentWidth}
                              />
                            </Grid>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Test"
                              variant="outlined"
                              fullWidth
                              sx={textfieldText}
                            />
                          )}
                          renderOption={(props, option) => (
                            <MenuItem
                              sx={menuItemStyle}
                              {...props}
                              key={option.id}
                            >
                              {option.name}{" "}
                            </MenuItem>
                          )}
                        />
                      </Grid>

                      <Grid
                        sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
                        item
                        sm={7}
                        lg={7}
                      >
                        <Box
                          display={"flex"}
                          justifyContent={"space-between"}
                          gap={"8px"}
                          alignItems={"center"}
                          width="100%"
                        >
                          <TextField
                            type="number"
                            value={1}
                            placeholder="quantity"
                            fullWidth
                            InputProps={{ readOnly: true }}
                            sx={{
                              ...textfieldTextBlueBorder,
                            }}
                          />
                          <TextField
                            type="number"
                            value={test.amount}
                            placeholder="Cost"
                            fullWidth
                            InputProps={{ readOnly: true }}
                            sx={{
                              ...textfieldTextBlueBorder,
                            }}
                          />
                          <TextField
                            type="number"
                            value={test.discount}
                            placeholder="Discount"
                            fullWidth
                            InputProps={{ readOnly: true }}
                            sx={{
                              ...textfieldTextBlueBorder,
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid sm={1} item lg={1}>
                        {/* <Box
                          sx={deleteTest}
                          onClick={() => handleDeleteTest(index, "xray")}
                        >
                          <RestoreFromTrashRoundedIcon
                            sx={{ width: "15px", height: "15px" }}
                            fontSize="small"
                          />
                        </Box> */}
                        <IconButton
                          sx={{
                            marginBottom: "7px",
                            display: !shouldShowSavePrintButton(inVoiceData)
                              ? "none"
                              : "",
                          }}
                          onClick={() =>
                            handleDeleteTest(index, "xray", test?.itemId)
                          }
                        >
                          <CloseIcon
                            sx={{
                              ...xBtn,
                              width: "23px",
                              height: "23px",
                            }}
                          />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <Grid
                    item
                    display={"flex"}
                    justifyContent={"space-between"}
                    xs={12}
                  >
                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Typography variant="body_Grey1">Discount:</Typography>
                      <Typography variant="body_Grey1">
                        {totalDiscountXray}
                      </Typography>
                    </Box>

                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Typography variant="title1_medium">
                        Net Amount
                      </Typography>
                      <TextField
                        type="number"
                        value={totalBillXray}
                        placeholder="Net amount"
                        InputProps={{ readOnly: true }}
                        sx={textfieldTextBlueBorder}
                      />
                    </Box>
                  </Grid>

                  <Grid item sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        marginTop: "12px",
                      }}
                    >
                      <Box>
                        {Object?.keys(inVoiceData)?.length > 0 &&
                          inVoiceData?.department_name === "X-Ray" &&
                          inVoiceData?.generated_at?.split(" ")[0] ===
                            dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY") && (
                            <Button
                              onClick={() => handleRefund("X-Ray")}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                borderRadius: "8px",
                                py: "3px",
                                marginRight: "10px",
                                border: "2px solid",
                                borderColor: "neutral.brown",
                                backgroundColor: "neutral.brown",
                                "&:hover": {
                                  backgroundColor: "neutral.brown",
                                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                },
                              }}
                              disabled={
                                buttonLoading ||
                                xRayTest?.length < 1 ||
                                inVoiceData?.generated_at?.split(" ")[0] !==
                                  dayjs()
                                    .tz("Asia/Kolkata")
                                    .format("DD-MM-YYYY")
                              }
                            >
                              <Typography variant="small_Text">
                                refund
                              </Typography>
                            </Button>
                          )}

                        {Object?.keys(inVoiceData)?.length > 0 &&
                          inVoiceData?.department_name === "X-Ray" && (
                            <ReactToPrint
                              trigger={() => (
                                <Button
                                  disabled={
                                    buttonLoading || xRayTest?.length < 1
                                  }
                                  sx={{
                                    ...primaryBtnTeal,
                                    color: "white",
                                    borderRadius: "8px",
                                    py: "3px",
                                    border: "2px solid",
                                    borderColor: "neutral.main",
                                    backgroundColor: "neutral.main",
                                    "&:hover": {
                                      backgroundColor: "neutral.main",
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                    },
                                    marginRight: "10px",
                                  }}
                                >
                                  <Typography variant="small_Text">
                                    Re-Print
                                  </Typography>
                                </Button>
                              )}
                              content={() => testReportRef.current}
                              onBeforeGetContent={() => handleRePrint()}
                            />
                          )}
                      </Box>

                      {shouldShowSavePrintButton(inVoiceData) && (
                        <Button
                          onClick={() => {
                            handleSaveAndPrint("X-Ray", xRayTest);
                          }}
                          // disabled={departmentTest?.["X-Ray"].find(
                          //   (testObj) => testObj.name === test.name,
                          // )}
                          disabled={buttonLoading}
                          sx={{
                            ...primaryBtnTeal,
                            color: "white",
                            py: "3px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          }}
                        >
                          <Typography variant="small_Text">
                            Save & Print
                          </Typography>
                        </Button>
                      )}
                    </Box>
                    {/* <ReactToPrint
                      trigger={() => (
                      
                      )}
                      content={() => testReportRef.current}
                      onBeforeGetContent={() =>
                        handleSaveAndPrint("X-Ray", xRayTest)
                      }
                    /> */}
                  </Grid>
                </Grid>
              </AccordionDetails>
            )}

            {/* {"----------Procedure / day care Test accordion----------"} */}
            {activeTab === "Procedure" && (
              <AccordionDetails
                sx={{ backgroundColor: "neutral.white", padding: "20px 20px" }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ alignItems: "center", justifyContent: "space-between" }}
                >
                  <Grid item sm={3} lg={3}>
                    <Typography variant="title1_medium">
                      Mode of Payment
                    </Typography>
                  </Grid>
                  <Grid item sm={8} lg={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            required
                            fullWidth
                            sx={{
                              ...selectFieldTextBlueBr,
                              minWidth: "120px",
                              width: "100%",
                              "&:hover": {
                                borderRadius: "8px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                              },
                            }}
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            name="payment_type"
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#A0A0A0" }}>
                                    Payment Mode
                                  </span>
                                );
                              }
                              return selected; // ✅ Show selected value
                            }}
                          >
                            <MenuItem value="Cash" sx={menuItemStyle}>
                              Cash
                            </MenuItem>
                            <MenuItem value="Card" sx={menuItemStyle}>
                              Card
                            </MenuItem>
                            <MenuItem value="Cheque" sx={menuItemStyle}>
                              Cheque
                            </MenuItem>
                            <MenuItem value="UPI" sx={menuItemStyle}>
                              UPI
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Grid item xs={12} mt={2}>
                  <Grid
                    container
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap={1}
                  >
                    <Grid item md={2} sm={5} mt={1}>
                      <Typography variant="title1_medium">Room No</Typography>
                      <TextField
                        // type="number"
                        value={admission?.room_no || ""}
                        onChange={(e) => {
                          setAdmission((prev) => ({
                            ...prev,
                            room_no: e.target.value,
                          }));
                        }}
                        placeholder="Room"
                        fullWidth
                        // inputProps={{
                        //   min: 0,
                        // }}
                        sx={{
                          ...textfieldTextBlueBorder,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            height: "40px",
                            padding: "9px !important",
                            "& input": {
                              padding: "8px",
                              fontSize: "14px",
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item md={2} sm={5} mt={1}>
                      <Typography variant="title1_medium">Bed No</Typography>
                      <TextField
                        type="number"
                        value={admission?.bed_no || ""}
                        onChange={(e) => {
                          setAdmission((prev) => ({
                            ...prev,
                            bed_no: e.target.value,
                          }));
                        }}
                        placeholder="Bed"
                        fullWidth
                        // inputProps={{
                        //   min: 0,
                        // }}
                        sx={{
                          ...textfieldTextBlueBorder,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            height: "40px",
                            padding: "9px !important",
                            "& input": {
                              padding: "8px",
                              fontSize: "14px",
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item md={3.5} sm={5} mt={1}>
                      <Typography variant="title1_medium">Check In</Typography>
                      <TextField
                        type="datetime-local"
                        value={admission?.checkin || ""}
                        onChange={(e) => {
                          setAdmission((prev) => ({
                            ...prev,
                            checkin: e.target.value,
                            // Reset checkout if it's earlier than the new checkin
                            checkout:
                              prev?.checkout && prev?.checkout < e.target.value
                                ? ""
                                : prev?.checkout,
                          }));
                        }}
                        placeholder="checkIn"
                        fullWidth
                        // sx={dateFiled}
                        sx={{
                          ...textfieldTextBlueBorder,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            height: "40px",
                            padding: "9px !important",
                            "& input": {
                              padding: "8px",
                              fontSize: "14px",
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item md={3.5} sm={5} mt={1}>
                      <Typography variant="title1_medium">Check Out</Typography>
                      <TextField
                        type="datetime-local"
                        value={admission?.checkout || ""}
                        onChange={(e) => {
                          setAdmission((prev) => ({
                            ...prev,
                            checkout: e.target.value,
                          }));
                        }}
                        inputProps={{
                          min: admission?.checkin || "", // restrict earlier than checkin
                        }}
                        placeholder="check-out"
                        fullWidth
                        // sx={dateFiled}
                        sx={{
                          ...textfieldTextBlueBorder,

                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            height: "40px",
                            padding: "9px !important",
                            "& input": {
                              padding: "8px",
                              fontSize: "14px",
                            },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  mt={1}
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <Grid
                    item
                    sm={4}
                    lg={4}
                    sx={{
                      paddingLeft: 0,
                    }}
                  >
                    <Typography variant="title1_medium">Test Name</Typography>
                  </Grid>
                  <Grid alignItems={"start"} item sm={7} lg={7}>
                    <Box
                      display={"flex"}
                      gap={"1px"}
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      width="100%"
                    >
                      <Typography p={0} variant="title1_medium">
                        Quantity
                      </Typography>
                      <Typography
                        sx={{ marginRight: "20px" }}
                        variant="title1_medium"
                      >
                        Cost
                      </Typography>
                      <Typography
                        sx={{ marginRight: "20px" }}
                        variant="title1_medium"
                      >
                        Discount
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    sm={1}
                    item
                    lg={1}
                    sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
                  >
                    {/* <Box
                      sx={addMoreTestStyle}
                      onClick={() => handleAddTest("procedure")}
                    >
                      <Typography variant="title1_medium">+</Typography>
                    </Box> */}
                    <IconButton
                      variant="contained"
                      sx={{ ...orangeButton, marginLeft: 1.2 }}
                      onClick={() => handleAddTest("procedure")}
                    >
                      <AddIcon
                        sx={{
                          width: "25px",
                          color: "neutral.white",
                          margin: "0px",
                          height: "25px",
                          padding: "0px",
                        }}
                      />
                    </IconButton>
                  </Grid>

                  {procedureTest?.map((test, index) => {
                    // console.log(test);
                    return (
                      <Grid
                        key={index}
                        item
                        lg={12}
                        gap={1}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                        }}
                      >
                        <Grid item sm={4} lg={4}>
                          <Autocomplete
                            clearIcon={false}
                            sx={{
                              ...textfieldTextBlueBorder,
                              textTransform: "capitalize",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                height: "40px",
                                padding: "9px !important",
                                "& input": {
                                  padding: "8px",
                                  fontSize: "14px",
                                },
                              },
                            }}
                            fullWidth
                            options={[
                              ...(departmentTest?.Procedure?.consumables || []),
                              ...(departmentTest?.Procedure?.tests || []),
                            ]}
                            isOptionEqualToValue={(option, value) =>
                              typeof option === "object" &&
                              typeof value === "object"
                                ? option?.id === value?.id
                                : option === value
                            }
                            getOptionLabel={(option) =>
                              typeof option === "object"
                                ? option?.name
                                : option || option?.name || null
                            }
                            groupBy={(option) =>
                              departmentTest?.Procedure?.consumables?.includes(
                                option,
                              )
                                ? "Consumables"
                                : "Tests"
                            }
                            value={(() => {
                              const selectedOption = procedureTest[index];
                              if (!selectedOption) return null;
                              // console.log(
                              //   selectedOption?.consumables_composite_fields,
                              //   "selectedOption consumables_composite_fields"
                              // );
                              // console.log(
                              //   selectedOption?.composite_fields,
                              //   "selectedOption"
                              // );
                              // Check if composite fields are available
                              if (
                                Array.isArray(
                                  selectedOption?.composite_fields,
                                ) &&
                                selectedOption.composite_fields.length > 0 &&
                                typeof selectedOption.composite_fields[0] ===
                                  "object"
                              ) {
                                return selectedOption.composite_fields[0];
                              }

                              // Check if consumable composite fields are available
                              if (
                                Array.isArray(
                                  selectedOption?.consumables_composite_fields,
                                ) &&
                                selectedOption.consumables_composite_fields
                                  .length > 0 &&
                                typeof selectedOption
                                  .consumables_composite_fields[0] === "object"
                              ) {
                                return (
                                  selectedOption
                                    ?.consumables_composite_fields[0] ||
                                  selectedOption?.name
                                );
                              }

                              // Return selectedOption or null if no composites
                              return selectedOption || null;
                            })()}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                handleSelectTest(index, newValue, "procedure");
                              }
                            }}
                            PopperComponent={(props) => (
                              <Grid item lg={8}>
                                <Popper
                                  {...props}
                                  placement="bottom-start"
                                  style={menuItemStyleContentWidth}
                                />
                              </Grid>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                sx={{ textTransform: "capitalize" }}
                                placeholder="Select Test"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                            renderOption={(props, option) => (
                              <MenuItem
                                sx={{
                                  ...menuItemStyle,
                                  textTransform: "capitalize",
                                }}
                                {...props}
                                key={option.id}
                              >
                                {option.name}
                              </MenuItem>
                            )}
                          />
                        </Grid>

                        <Grid
                          item
                          sm={7}
                          lg={7}
                          sx={{ "&.MuiGrid-item": { paddingLeft: "0px" } }}
                        >
                          <Box
                            display={"flex"}
                            justifyContent={"space-between"}
                            gap={"8px"}
                            alignItems={"center"}
                            width="100%"
                          >
                            <TextField
                              type="number"
                              value={test?.quantity}
                              // defaultValue={1}
                              placeholder="Quantity"
                              fullWidth
                              onChange={(e) => {
                                // const newQty = e.target.value.replace(
                                //   /[^0-9]/g,
                                //   ""
                                // );
                                const newQty = e.target.value;
                                if (+newQty > 0) {
                                  setProcedureTest((prev) => {
                                    const updatedTests = [...prev];
                                    updatedTests[index] = {
                                      ...updatedTests[index],
                                      quantity: +newQty,
                                      amount: Math.ceil(
                                        +newQty * test?.cost_per_unit,
                                      ),
                                      discount: Math.ceil(
                                        +newQty * test?.discount_per_unit,
                                      ),
                                    };
                                    return updatedTests;
                                  });
                                } else {
                                  setProcedureTest((prev) => {
                                    const updatedTests = [...prev];
                                    updatedTests[index] = {
                                      ...updatedTests[index],
                                      quantity: newQty, // Let raw value be temporarily a string
                                    };
                                    return updatedTests;
                                  });
                                }
                              }}
                              // onChange={(e) => {
                              //   const newQty = e.target.value;
                              //   setProcedureTest((prev) => {
                              //     const updatedTests = [...prev];
                              //     updatedTests[index] = {
                              //       ...updatedTests[index],
                              //       quantity: newQty, // Let raw value be temporarily a string
                              //     };
                              //     return updatedTests;
                              //   });
                              // }}
                              onBlur={(e) => {
                                const newQty = +e.target.value;
                                setProcedureTest((prev) => {
                                  const updatedTests = [...prev];
                                  const validQty = newQty > 0 ? newQty : 1;
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    quantity: validQty,
                                    amount: Math.ceil(
                                      validQty * test?.cost_per_unit,
                                    ),
                                    discount: Math.ceil(
                                      validQty * test?.discount_per_unit,
                                    ),
                                  };
                                  return updatedTests;
                                });
                              }}
                              sx={{
                                ...textfieldTextBlueBorder,
                              }}
                            />

                            <TextField
                              type="number"
                              // defaultValue={}
                              value={test?.amount || ""}
                              placeholder="Cost"
                              fullWidth
                              // onChange={(e) => {
                              //   const newQty = +e.target.value;
                              //   // Update the procedureTest array
                              //   setProcedureTest((prev) => {
                              //     // Create a copy of the previous array
                              //     const updatedTests = [...prev];

                              //     updatedTests[index] = {
                              //       ...updatedTests[index],
                              //       amount: newQty > 0 ? newQty : 1,
                              //       cost: newQty > 0 ? newQty : 1,
                              //     };
                              //     return updatedTests; // Return the updated array
                              //   });
                              // }}
                              onChange={(e) => {
                                // const newQty = e.target.value.replace(
                                //   /[^0-9]/g,
                                //   ""
                                // ); // Get the raw input
                                const newQty = e.target.value;

                                if (+newQty > 0) {
                                  setProcedureTest((prev) => {
                                    const updatedTests = [...prev];
                                    updatedTests[index] = {
                                      ...updatedTests[index],
                                      amount: Math.ceil(+newQty), // Temporarily set the raw input
                                      cost_per_unit:
                                        test.quantity > 0
                                          ? Math.ceil(+newQty / test.quantity)
                                          : 0,
                                    };
                                    return updatedTests;
                                  });
                                } else {
                                  setProcedureTest((prev) => {
                                    const updatedTests = [...prev];
                                    updatedTests[index] = {
                                      ...updatedTests[index],
                                      amount: Math.ceil(+newQty), // Temporarily set the raw input
                                    };
                                    return updatedTests;
                                  });
                                }
                              }}
                              onBlur={(e) => {
                                // const newQty = +e.target.value; // Convert to number on blur

                                let newAmount = parseFloat(e.target.value);

                                if (isNaN(newAmount) || newAmount <= 0) {
                                  newAmount = 1; // Set minimum valid value
                                }

                                if (+newAmount < +test?.discount) {
                                  newAmount = +test?.discount; // Auto-correct to discount
                                  showToast(
                                    "Cost cannot be less than discount. Adjusted automatically.",
                                    "ERROR",
                                  );
                                }
                                setProcedureTest((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    amount: newAmount > 0 ? newAmount : 1, // Validate on blur
                                    cost: newAmount > 0 ? newAmount : 1, // Validate on blur
                                  };
                                  return updatedTests;
                                });
                              }}
                              inputProps={{
                                min: 1,
                              }}
                              sx={{
                                ...textfieldTextBlueBorder,
                              }}
                            />

                            <TextField
                              type="number"
                              value={test?.discount || ""}
                              placeholder="Discount"
                              fullWidth
                              onChange={(e) => {
                                const newQty = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                ); // Raw input
                                if (newQty > (+test?.amount || +test?.cost)) {
                                  showToast(
                                    "Discount cannot be greater than the test cost.",
                                    "ERROR",
                                  );
                                  return;
                                }
                                setProcedureTest((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    discount: +newQty,
                                    discount_per_unit:
                                      test.quantity > 0
                                        ? Math.ceil(+newQty / +test.quantity)
                                        : 0,
                                  };
                                  return updatedTests;
                                });
                              }}
                              onBlur={(e) => {
                                const newQty = +e.target.value; // Convert to number on blur
                                setProcedureTest((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    discount: newQty < 0 ? 0 : newQty,
                                  };
                                  return updatedTests;
                                });
                              }}
                              inputProps={{
                                min: 0,
                                readOnly: true,
                              }}
                              // InputProps={{ readOnly: true }}
                              sx={{
                                ...textfieldTextBlueBorder,
                              }}
                            />
                            {/* <TextField
                              type="number"
                              defaultValue={0}
                              value={test?.discount}
                              placeholder="Discount"
                              fullWidth
                              // onChange={(e) => {
                              //   const newQty = +e.target.value;
                              //   // Update the procedureTest array
                              //   setProcedureTest((prev) => {
                              //     const updatedTests = [...prev];
                              //     updatedTests[index] = {
                              //       ...updatedTests[index],
                              //       discount: newQty > 0 ? newQty : 0,
                              //     };
                              //     return updatedTests;
                              //   });
                              // }}
                              onChange={(e) => {
                                const newQty = e.target.value.replace(/[^0-9]/g, ''); // Raw input
                                if (newQty > (test?.amount || test?.cost)) {
                                  showToast("Discount cannot be greater than the test cost.", "ERROR");
                                  return;
                                }
                                setProcedureTest((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    discount: newQty, // Temporarily store raw input
                                  };
                                  return updatedTests;
                                });
                              }}
                              onBlur={(e) => {
                                const newQty = +e.target.value;
                                setProcedureTest((prev) => {
                                  const updatedTests = [...prev];
                                  updatedTests[index] = {
                                    ...updatedTests[index],
                                    discount: newQty < 0 ? 0 : newQty,
                                  };
                                  return updatedTests;
                                });
                              }}
                              inputProps={{
                                min: 0,
                                // Allow decimal steps of 0.01 for two decimal places
                                // pattern: "[0-9]*([.][0-9]{0,2})?",
                              }}
                              // InputProps={{ readOnly: true }}
                              sx={{
                                ...textfieldTextBlueBorder,
                              }}
                            /> */}
                          </Box>
                        </Grid>

                        <Grid sm={1} item lg={1}>
                          <IconButton
                            sx={{
                              marginBottom: "7px",
                              marginLeft: 1.4,
                              display: !shouldShowSavePrintButton(inVoiceData)
                                ? "none"
                                : "",
                            }}
                            onClick={() =>
                              handleDeleteTest(index, "procedure", test?.itemId)
                            }
                          >
                            <CloseIcon
                              sx={{
                                ...xBtn,
                                width: "23px",
                                height: "23px",
                              }}
                            />
                          </IconButton>
                        </Grid>
                      </Grid>
                    );
                  })}

                  <Grid
                    item
                    display={"flex"}
                    justifyContent={"space-between"}
                    xs={12}
                  >
                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Typography variant="body_Grey1">
                        {" "}
                        Net Discount:
                      </Typography>
                      <Typography variant="body_Grey1">
                        {totalDiscountProcedure}
                      </Typography>
                    </Box>

                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      justifyContent={"flex-end"}
                    >
                      <Typography variant="title1_medium">
                        Net Amount
                      </Typography>
                      <TextField
                        type="number"
                        value={totalBillProcedure}
                        placeholder="Net amount"
                        InputProps={{ readOnly: true }}
                        sx={{
                          ...textfieldTextBlueBorder,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Box
                    sx={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      marginTop: "20px",
                    }}
                  >
                    <Box>
                      {Object.keys(inVoiceData).length > 0 &&
                        (inVoiceData?.department_name === "Procedure" ||
                          inVoiceData?.department_name === "Daycare") &&
                        inVoiceData?.generated_at?.split(" ")[0] ===
                          dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY") && (
                          <Button
                            onClick={() => handleRefund("Procedure")}
                            disabled={
                              buttonLoading ||
                              procedureTest?.length < 0 ||
                              inVoiceData?.generated_at?.split(" ")[0] !==
                                dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY")
                            }
                            sx={{
                              ...primaryBtnTeal,
                              color: "white",
                              borderRadius: "8px",
                              py: "3px",
                              mr: "10px",
                              border: "2px solid",
                              borderColor: "neutral.brown",
                              backgroundColor: "neutral.brown",
                              "&:hover": {
                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                backgroundColor: "neutral.brown",
                              },
                            }}
                          >
                            <Typography variant="small_Text">refund</Typography>
                          </Button>
                        )}
                      {Object.keys(inVoiceData).length > 0 &&
                        (inVoiceData?.department_name === "Procedure" ||
                          inVoiceData?.department_name === "Daycare") && (
                          <ReactToPrint
                            trigger={() => (
                              <Button
                                // fullWidth
                                // onClick={handleRePrint}
                                disabled={
                                  buttonLoading || procedureTest?.length < 0
                                }
                                sx={{
                                  ...primaryBtnTeal,
                                  color: "white",
                                  borderRadius: "8px",
                                  py: "3px",
                                  mr: "10px",
                                  border: "2px solid",
                                  borderColor: "neutral.main",
                                  backgroundColor: "neutral.main",
                                  "&:hover": {
                                    boxShadow:
                                      "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                    backgroundColor: "neutral.main",
                                  },
                                }}
                              >
                                <Typography variant="small_Text">
                                  Re-Print
                                </Typography>
                              </Button>
                            )}
                            content={() => testReportRef.current}
                            onBeforeGetContent={() => handleRePrint()}
                          />
                        )}
                    </Box>

                    <Box>
                      {shouldShowSavePrintButton(inVoiceData) && (
                        <Button
                          // disabled={departmentTest?.Procedure?.find(
                          //   (testObj) => testObj.name === test.name
                          // )}
                          disabled={buttonLoading}
                          onClick={() =>
                            handleSaveAndPrint("Procedure", procedureTest)
                          }
                          sx={{
                            ...primaryBtnTeal,
                            color: "white",
                            py: "3px",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                            fontSize: {
                              md: "10px !important",
                            },
                          }}
                        >
                          <Typography variant="small_Text">
                            Save & Print
                          </Typography>
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </AccordionDetails>
            )}

            {/* {"----------Dietician Test accordion----------"} */}
            {activeTab === "Dietician" && (
              <AccordionDetails
                sx={{ backgroundColor: "white", padding: "20px 20px" }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ alignItems: "center", justifyContent: "space-between" }}
                >
                  <Grid item sm={3} lg={3}>
                    <Typography variant="title1_medium">
                      Mode of Payment
                    </Typography>
                  </Grid>
                  <Grid item sm={8} lg={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            required
                            fullWidth
                            sx={{
                              ...selectFieldTextBlueBr,
                              minWidth: "120px",
                              width: "100%",
                              "&:hover": {
                                borderRadius: "8px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                              },
                            }}
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            name="payment_type"
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#A0A0A0" }}>
                                    Payment Mode
                                  </span>
                                );
                              }
                              return selected; // ✅ Show selected value
                            }}
                          >
                            <MenuItem value="Cash" sx={menuItemStyle}>
                              Cash
                            </MenuItem>
                            <MenuItem value="Card" sx={menuItemStyle}>
                              Card
                            </MenuItem>
                            <MenuItem value="Cheque" sx={menuItemStyle}>
                              Cheque
                            </MenuItem>
                            <MenuItem value="UPI" sx={menuItemStyle}>
                              UPI
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  mt={2}
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    // flexWrap: "nowrap",
                    width: "100%",
                  }}
                >
                  <Grid item lg={4} sm={4}>
                    {" "}
                    <Select
                      value={selectedSpecialist?.Dietician?.id || ""}
                      onChange={(e) => handleSpecialistChange(e, "Dietician")}
                      defaultValue="default"
                      fullWidth
                      // sx={selectField}
                      sx={{
                        ...textfieldTextBlueBorder,
                        borderRadius: "8px", // Apply 20px border radius to the entire Select component
                        "& .MuiSelect-select": {
                          borderRadius: "8px",
                          padding: "8px !important", // Adjust padding if needed
                        },
                      }}
                    >
                      <MenuItem disabled value="0">
                        Dietician
                      </MenuItem>
                      {departmentTest?.Dietician?.specialists?.map((el) => (
                        <MenuItem key={el.id} sx={menuItemStyle} value={el.id}>
                          {el.full_name}
                        </MenuItem>
                      ))}
                    </Select>{" "}
                  </Grid>
                  <Grid item lg={4} sm={4}>
                    <Select
                      value={selectedSpecialist?.DieticianPlan?.id || ""}
                      onChange={(e) =>
                        handleChangePlan(e, "Dietician", "DieticianPlan")
                      }
                      defaultValue="default"
                      fullWidth
                      // sx={selectField}
                      sx={{
                        ...textfieldTextBlueBorder,
                        borderRadius: "8px", // Apply 20px border radius to the entire Select component
                        "& .MuiSelect-select": {
                          borderRadius: "8px",
                          padding: "8px !important", // Adjust padding if needed
                        },
                      }}
                    >
                      <MenuItem disabled value="1">
                        Plans
                      </MenuItem>
                      {selectedSpecialist?.Dietician?.specialist_plans?.map(
                        (el) => (
                          <MenuItem
                            key={el.id}
                            sx={menuItemStyle}
                            value={el.id}
                          >
                            {el?.title}
                          </MenuItem>
                        ),
                      )}
                    </Select>{" "}
                  </Grid>
                  <Grid item sm={4} lg={4}>
                    {selectedSpecialist?.DieticianPlan?.id &&
                      selectedSpecialist?.Dietician?.specialist_plans?.map(
                        (el) => (
                          <Box
                            sx={{
                              backgroundColor: "rgba(204, 204, 204, 0.1)",
                              border: "1px solid #0067FF",
                              padding: "8px 0px",
                              borderRadius: "8px",
                              display:
                                selectedSpecialist?.DieticianPlan?.id === el.id
                                  ? "flex"
                                  : "none",
                              justifyContent: "center",
                              color: "grey",
                            }}
                            key={el.id}
                            alignItems={"center"}
                            // sx={menuItemStyle}
                            value={el.id}
                          >
                            {selectedSpecialist?.DieticianPlan?.id === el.id &&
                              el?.amount}
                          </Box>
                        ),
                      )}
                  </Grid>
                </Grid>

                <Box
                  mt={2}
                  sx={{
                    justifyContent: "space-between",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <Box>
                    {Object.keys(inVoiceData).length > 0 &&
                      inVoiceData?.department_name === "Dietician" &&
                      inVoiceData?.generated_at?.split(" ")[0] ===
                        dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY") && (
                        <Button
                          disabled={
                            buttonLoading ||
                            inVoiceData?.generated_at?.split(" ")[0] !==
                              dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY")
                          }
                          onClick={() => handleRefund("Dietician")}
                          sx={{
                            ...primaryBtnTeal,
                            color: "white",
                            borderRadius: "8px",
                            py: "3px",
                            mr: "10px",
                            border: "2px solid",
                            borderColor: "neutral.brown",
                            backgroundColor: "neutral.brown",
                            "&:hover": {
                              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                              backgroundColor: "neutral.brown",
                            },
                          }}
                        >
                          <Typography variant="small_Text">refund</Typography>
                        </Button>
                      )}
                    {Object.keys(inVoiceData).length > 0 &&
                      inVoiceData?.department_name === "Dietician" && (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              // fullWidth
                              // onClick={handleRePrint}
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                borderRadius: "8px",
                                py: "3px",
                                mr: "10px",
                                border: "2px solid",
                                borderColor: "neutral.main",
                                backgroundColor: "neutral.main",
                                "&:hover": {
                                  backgroundColor: "neutral.main",
                                },
                              }}
                            >
                              <Typography variant="small_Text">
                                Re-Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() => handleRePrint()}
                        />
                      )}
                  </Box>

                  {shouldShowSavePrintButton(inVoiceData) && (
                    <Box>
                      {patientData?.payload &&
                      Object?.keys(patientData?.payload)?.length > 3 &&
                      inVoiceData?.department_name === "Dietician" &&
                      rePrint?.Dietician === false ? (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                py: "3px",
                              }}
                              disabled={buttonLoading}
                            >
                              <Typography variant="small_Text">
                                Save & Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() =>
                            handleSaveAndPrintPlans(
                              "Dietician",
                              selectedSpecialist?.DieticianPlan,
                            )
                          }
                        />
                      ) : (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                py: "3px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography variant="small_Text">
                                Save & Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() =>
                            handleSaveAndPrintPlans(
                              "Dietician",
                              selectedSpecialist?.DieticianPlan,
                            )
                          }
                        />
                      )}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            )}

            {/* {"----------Physiotherapist Test accordion----------"} */}
            {activeTab === "Physiotherapist" && (
              <AccordionDetails
                sx={{ backgroundColor: "white", padding: "20px 20px" }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ alignItems: "center", justifyContent: "space-between" }}
                >
                  <Grid item sm={3} lg={3}>
                    <Typography variant="title1_medium">
                      Mode of Payment
                    </Typography>
                  </Grid>
                  <Grid item sm={8} lg={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            required
                            fullWidth
                            sx={{
                              ...selectFieldTextBlueBr,
                              minWidth: "120px",
                              width: "100%",
                              "&:hover": {
                                borderRadius: "8px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                              },
                            }}
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            name="payment_type"
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#A0A0A0" }}>
                                    Payment Mode
                                  </span>
                                );
                              }
                              return selected; // ✅ Show selected value
                            }}
                          >
                            <MenuItem value="Cash" sx={menuItemStyle}>
                              Cash
                            </MenuItem>
                            <MenuItem value="Card" sx={menuItemStyle}>
                              Card
                            </MenuItem>
                            <MenuItem value="Cheque" sx={menuItemStyle}>
                              Cheque
                            </MenuItem>
                            <MenuItem value="UPI" sx={menuItemStyle}>
                              UPI
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  mt={2}
                  container
                  spacing={1}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <Grid item lg={4} sm={4}>
                    {" "}
                    <Select
                      value={selectedSpecialist?.Physiotherapist?.id || ""}
                      onChange={(e) =>
                        handleSpecialistChange(e, "Physiotherapist")
                      }
                      defaultValue="default"
                      fullWidth
                      sx={{
                        ...textfieldTextBlueBorder,
                        borderRadius: "8px", // Apply 20px border radius to the entire Select component
                        "& .MuiSelect-select": {
                          borderRadius: "8px",
                          padding: "8px !important", // Adjust padding if needed
                        },
                      }}
                    >
                      <MenuItem disabled value="0">
                        Physiotherapist
                      </MenuItem>
                      {departmentTest?.Physiotherapist?.specialists?.map(
                        (el) => (
                          <MenuItem key={el} sx={menuItemStyle} value={el.id}>
                            {el.full_name}
                          </MenuItem>
                        ),
                      )}
                    </Select>{" "}
                  </Grid>
                  <Grid item lg={4} sm={4}>
                    <Select
                      value={selectedSpecialist?.PhysiotherapistPlan?.id || ""}
                      onChange={(e) =>
                        handleChangePlan(
                          e,
                          "Physiotherapist",
                          "PhysiotherapistPlan",
                        )
                      }
                      defaultValue="default"
                      fullWidth
                      sx={{
                        ...textfieldTextBlueBorder,
                        borderRadius: "8px", // Apply 20px border radius to the entire Select component
                        "& .MuiSelect-select": {
                          borderRadius: "8px",
                          padding: "8px !important", // Adjust padding if needed
                        },
                      }}
                    >
                      <MenuItem disabled value="1">
                        Plans
                      </MenuItem>
                      {selectedSpecialist?.Physiotherapist?.specialist_plans?.map(
                        (el) => (
                          <MenuItem
                            key={el.id}
                            sx={menuItemStyle}
                            value={el.id}
                          >
                            {el?.title}
                          </MenuItem>
                        ),
                      )}
                    </Select>{" "}
                  </Grid>
                  <Grid item lg={4} sm={4}>
                    {selectedSpecialist?.PhysiotherapistPlan?.id &&
                      selectedSpecialist?.Physiotherapist?.specialist_plans?.map(
                        (el) => (
                          <Box
                            sx={{
                              backgroundColor: "rgba(204, 204, 204, 0.1)",
                              border: "1px solid #0067FF",
                              padding: "8px 0px",
                              borderRadius: "8px",
                              display:
                                selectedSpecialist?.PhysiotherapistPlan?.id ===
                                el.id
                                  ? "flex"
                                  : "none",
                              justifyContent: "center",
                              color: "grey",
                            }}
                            key={el.id}
                            alignItems={"center"}
                            // sx={menuItemStyle}
                            value={el.id}
                          >
                            {selectedSpecialist?.PhysiotherapistPlan?.id ===
                              el.id && el?.amount}
                          </Box>
                        ),
                      )}
                  </Grid>
                </Grid>

                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Box>
                    {Object.keys(inVoiceData).length > 0 &&
                      inVoiceData?.department_name === "Physiotherapist" &&
                      inVoiceData?.generated_at?.split(" ")[0] ===
                        dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY") && (
                        <Button
                          onClick={() => handleRefund("Physiotherapist")}
                          disabled={
                            buttonLoading ||
                            inVoiceData?.generated_at?.split(" ")[0] !==
                              dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY")
                          }
                          sx={{
                            ...primaryBtnTeal,
                            color: "white",
                            borderRadius: "8px",
                            py: "3px",
                            mr: "10px",
                            border: "2px solid",
                            borderColor: "neutral.brown",
                            backgroundColor: "neutral.brown",
                            "&:hover": {
                              backgroundColor: "neutral.brown",
                            },
                          }}
                        >
                          <Typography variant="small_Text">refund</Typography>
                        </Button>
                      )}
                    {Object.keys(inVoiceData).length > 0 &&
                      inVoiceData?.department_name === "Physiotherapist" && (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              // onClick={handleRePrint}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                borderRadius: "8px",
                                py: "3px",
                                mr: "10px",
                                border: "2px solid",
                                borderColor: "neutral.main",
                                backgroundColor: "neutral.main",
                                "&:hover": {
                                  backgroundColor: "neutral.main",
                                },
                              }}
                              disabled={buttonLoading}
                            >
                              <Typography variant="small_Text">
                                Re-Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() => handleRePrint()}
                        />
                      )}
                  </Box>
                  {shouldShowSavePrintButton(inVoiceData) && (
                    <Box>
                      {patientData?.payload &&
                      Object.keys(patientData?.payload)?.length > 3 &&
                      rePrint?.Physiotherapist === false ? (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                py: "3px",
                              }}
                            >
                              <Typography variant="small_Text">
                                Save & Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() =>
                            handleSaveAndPrintPlans(
                              "Physiotherapist",
                              selectedSpecialist?.PhysiotherapistPlan,
                            )
                          }
                        />
                      ) : (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                py: "3px",
                              }}
                            >
                              <Typography variant="small_Text">
                                Save & Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() =>
                            handleSaveAndPrintPlans(
                              "Physiotherapist",
                              selectedSpecialist?.PhysiotherapistPlan,
                            )
                          }
                        />
                      )}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            )}

            {/* {"----------Psychologist Test accordion----------"} */}
            {activeTab === "Psychologist" && (
              <AccordionDetails
                sx={{ backgroundColor: "white", padding: "20px 20px" }}
              >
                <Grid
                  container
                  spacing={0}
                  sx={{ alignItems: "center", justifyContent: "space-between" }}
                >
                  <Grid item sm={3} lg={3}>
                    <Typography variant="title1_medium">
                      Mode of Payment
                    </Typography>
                  </Grid>
                  <Grid item sm={8} lg={8}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            required
                            fullWidth
                            sx={{
                              ...selectFieldTextBlueBr,
                              minWidth: "120px",
                              width: "100%",
                              "&:hover": {
                                borderRadius: "8px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                              },
                            }}
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            name="payment_type"
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#A0A0A0" }}>
                                    Payment Mode
                                  </span>
                                );
                              }
                              return selected; // ✅ Show selected value
                            }}
                          >
                            <MenuItem value="Cash" sx={menuItemStyle}>
                              Cash
                            </MenuItem>
                            <MenuItem value="Card" sx={menuItemStyle}>
                              Card
                            </MenuItem>
                            <MenuItem value="Cheque" sx={menuItemStyle}>
                              Cheque
                            </MenuItem>
                            <MenuItem value="UPI" sx={menuItemStyle}>
                              UPI
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  mt={2}
                  container
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <Grid item lg={4} sm={4}>
                    {" "}
                    <Select
                      value={selectedSpecialist?.Psychologist?.id || ""}
                      onChange={(e) =>
                        handleSpecialistChange(e, "Psychologist")
                      }
                      defaultValue="default"
                      fullWidth
                      //  sx={selectField}
                      sx={{
                        ...textfieldTextBlueBorder,
                        borderRadius: "8px", // Apply 20px border radius to the entire Select component
                        "& .MuiSelect-select": {
                          borderRadius: "8px",
                          padding: "8px !important", // Adjust padding if needed
                        },
                      }}
                    >
                      <MenuItem disabled value="0">
                        Psychologist
                      </MenuItem>
                      {departmentTest?.Psychologist?.specialists?.map((el) => (
                        <MenuItem key={el.id} sx={menuItemStyle} value={el.id}>
                          {el?.full_name}
                        </MenuItem>
                      ))}
                    </Select>{" "}
                  </Grid>
                  <Grid item lg={4} sm={4}>
                    <Select
                      value={selectedSpecialist?.PsychologistPlan?.id || ""}
                      onChange={(e) =>
                        handleChangePlan(e, "Psychologist", "PsychologistPlan")
                      }
                      defaultValue="default"
                      fullWidth
                      //  sx={selectField}
                      sx={{
                        ...textfieldTextBlueBorder,
                        borderRadius: "8px", // Apply 20px border radius to the entire Select component
                        "& .MuiSelect-select": {
                          borderRadius: "8px",
                          padding: "8px !important", // Adjust padding if needed
                        },
                      }}
                    >
                      <MenuItem disabled value="1">
                        Plans
                      </MenuItem>
                      {selectedSpecialist?.Psychologist?.specialist_plans?.map(
                        (el) => (
                          <MenuItem
                            key={el.id}
                            sx={menuItemStyle}
                            value={el.id}
                          >
                            {el?.title}
                          </MenuItem>
                        ),
                      )}
                    </Select>{" "}
                  </Grid>
                  <Grid item sm={4} lg={4}>
                    {selectedSpecialist?.PsychologistPlan?.id &&
                      selectedSpecialist?.Psychologist?.specialist_plans?.map(
                        (el) => (
                          <Box
                            sx={{
                              backgroundColor: "rgba(204, 204, 204, 0.1)",
                              border: "1px solid #0067FF",
                              padding: "8px 0px",
                              borderRadius: "8px",
                              display:
                                selectedSpecialist?.PsychologistPlan?.id ===
                                el.id
                                  ? "flex"
                                  : "none",
                              justifyContent: "center",
                              color: "grey",
                            }}
                            key={el.id}
                            alignItems={"center"}
                            // sx={menuItemStyle}
                            value={el.id}
                          >
                            {selectedSpecialist?.PsychologistPlan?.id ===
                              el.id && el?.amount}
                          </Box>
                        ),
                      )}
                  </Grid>
                </Grid>

                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Box>
                    {Object.keys(inVoiceData).length > 0 &&
                      inVoiceData?.department_name === "Psychologist" &&
                      inVoiceData?.generated_at?.split(" ")[0] ===
                        dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY") && (
                        <Button
                          disabled={
                            buttonLoading ||
                            inVoiceData?.generated_at?.split(" ")[0] !==
                              dayjs().tz("Asia/Kolkata").format("DD-MM-YYYY")
                          }
                          onClick={() => handleRefund("Psychologist")}
                          sx={{
                            ...primaryBtnTeal,
                            color: "white",
                            borderRadius: "8px",
                            py: "3px",
                            mr: "10px",
                            border: "2px solid",
                            borderColor: "neutral.brown",
                            backgroundColor: "neutral.brown",
                            "&:hover": {
                              backgroundColor: "neutral.brown",
                            },
                          }}
                        >
                          <Typography variant="small_Text">refund</Typography>
                        </Button>
                      )}
                    {Object.keys(inVoiceData).length > 0 &&
                      inVoiceData?.department_name === "Psychologist" && (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              //  fullWidth
                              // onClick={handleRePrint}
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                borderRadius: "8px",
                                py: "3px",
                                mr: "10px",
                                border: "2px solid",
                                borderColor: "neutral.main",
                                backgroundColor: "neutral.main",
                                "&:hover": {
                                  backgroundColor: "neutral.main",
                                },
                              }}
                            >
                              <Typography variant="small_Text">
                                Re-Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() => handleRePrint()}
                        />
                      )}
                  </Box>
                  {}
                  {shouldShowSavePrintButton(inVoiceData) && (
                    <Box>
                      {patientData?.payload &&
                      Object.keys(patientData?.payload)?.length > 3 &&
                      rePrint?.Psychologist === false ? (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                py: "3px",
                              }}
                            >
                              <Typography variant="small_Text">
                                Save & Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() =>
                            handleSaveAndPrintPlans(
                              "Psychologist",
                              selectedSpecialist?.PsychologistPlan,
                            )
                          }
                        />
                      ) : (
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              disabled={buttonLoading}
                              sx={{
                                ...primaryBtnTeal,
                                color: "white",
                                py: "3px",
                              }}
                            >
                              <Typography variant="small_Text">
                                Save & Print
                              </Typography>
                            </Button>
                          )}
                          content={() => testReportRef.current}
                          onBeforeGetContent={() =>
                            handleSaveAndPrintPlans(
                              "Psychologist",
                              selectedSpecialist?.PsychologistPlan,
                            )
                          }
                        />
                      )}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            )}

            {/* {"----------IPD  accordion----------"} */}
            {activeTab === "IPD" && (
              <IpdInvoices
                departmentID={
                  listData?.payload?.departments?.find((d) => d?.name === "IPD")
                    ?.id
                }
              />
            )}
          </Box>
        )}
      </Grid>
      <ReportPrint ref={testReportRef} />
    </>
  );
};

export default PatientsTest;
